module.exports = __webpack_public_path__ + "static/media/sign-in.7127497d.svg";